import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Typography } from "@mui/material";
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function DropdownMenu({
  name,
  menuList,
  handleSelect,
  selectedMenu,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const selectedLabel =
    menuList?.find((m) => m.value === selectedMenu)?.label || name;
  return (
    <Box>
      <Button
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          px: 3,
          py: 1,
          borderRadius: "999px",
          backgroundColor: "#f1f1f2",
          color: "#000",
          fontWeight: 600,
          fontSize: { xs: "13px", sm: "14px", md: "15px" },
          textTransform: "none",
          border: "none",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#ececec",
            border: "none",
          },
        }}
      >
        {selectedLabel}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            borderRadius: "15px",
            minWidth: "260px",
            boxShadow: "0px 10px 30px rgba(0,0,0,0.15)",
            overflow: "hidden",
          },
        }}
      >
        {menuList.map((menu, i) => {
          const isSelected = selectedMenu === menu.value;

          return (
            <MenuItem
              key={i}
              onClick={() => {
                handleSelect(menu.value);
                handleClose();
              }}
              sx={{
                py: { xs: 1.2, sm: 1.5, md: 1.5, lg: 1.5 },
                px: 2.5,
                fontSize: { xs: "13px", sm: "14px", md: "15px" },
                fontWeight: 500,
                backgroundColor: isSelected ? "#f1f1f2" : "#fff",
                "&:hover": {
                  backgroundColor: "#f6f6f6",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* circle icon */}
                <Box
                  sx={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    border: "2px solid black",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: isSelected ? "#000" : "transparent",
                  }}
                >
                  {isSelected && (
                    <CheckIcon sx={{ fontSize: "16px", color: "#fff" }} />
                  )}
                </Box>

                <Typography
                  sx={{
                    fontSize: { xs: "13px", sm: "14px", md: "15px" },
                    fontWeight: 600,
                  }}
                >
                  {menu.label}
                </Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
}
